__turbopack_context__.v({
  "chevron": "side-nav-menu-module-scss-module__7NpZxa__chevron",
  "chevronExpanded": "side-nav-menu-module-scss-module__7NpZxa__chevronExpanded",
  "collapse": "side-nav-menu-module-scss-module__7NpZxa__collapse",
  "icon": "side-nav-menu-module-scss-module__7NpZxa__icon",
  "menu": "side-nav-menu-module-scss-module__7NpZxa__menu",
  "rowIn": "side-nav-menu-module-scss-module__7NpZxa__rowIn",
  "subItems": "side-nav-menu-module-scss-module__7NpZxa__subItems",
  "toggle": "side-nav-menu-module-scss-module__7NpZxa__toggle",
});
